import React from 'react';
import { useNavigate } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEOHead
        title="Page Not Found"
        description="The page you're looking for doesn't exist. Browse our Indian ethnic wear collections."
        url="/404"
      />
      <div className="page-state">
        <div className="ps-emoji" aria-hidden="true">🧵</div>
        <h1>404</h1>
        <h2>This page seems to have wandered off</h2>
        <p>
          The page you're looking for doesn't exist or may have been moved.
          Let's get you back to our collections.
        </p>
        <div className="ps-actions">
          <button className="btn-primary" onClick={() => navigate('/')}>Go Home</button>
          <button className="btn-gold" onClick={() => navigate('/products')}>Browse Collections</button>
        </div>
      </div>
    </>
  );
};

export default NotFound;
